import { FileArrowDown } from '@phosphor-icons/react';

export default FileArrowDown;